import baxterDark from '@/assets/baxter-dark-300w.webp';
import baxterLight from '@/assets/baxter-light-300w.webp';
import { cn } from '@/lib/utils';

/** Baxter's face, swapped per theme like the WordPuppi wordmark is. Decorative
 *  everywhere it appears — the label next to it already names him. */
export function BaxterMark({ className }: { className?: string }) {
  return (
    <>
      <img src={baxterLight} alt="" aria-hidden="true" className={cn('max-w-none shrink-0 dark:hidden', className)} />
      <img src={baxterDark} alt="" aria-hidden="true" className={cn('hidden max-w-none shrink-0 dark:block', className)} />
    </>
  );
}
